const pageExpertises = document.getElementsByClassName("page-expertises")[0];
const currentPath = document.URL;
let anchor = currentPath.split('#');

if(pageExpertises){
    const inputsTab = Array.from(document.getElementsByClassName("view_input"));

    inputsTab.forEach((input)=>{
        input.addEventListener('change', function (event) {
            anchor = event.target.dataset.anchor;
            location.hash = anchor;
          });
    });

    if(anchor.length > 1){
        let input = inputsTab.filter((input) => input.dataset.anchor === '#'+anchor[1]);

        if(input[0]){
            input[0].checked = true;
        }
    }
}
